import { useCallback, useEffect, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import { useConfigContext } from 'config/ui/ConfigContext'

import { type POD } from '../../domain/Document'
import { getShipmentPODs } from '../../use-cases/getShipmentPODs'

export function useGetPOD(shipmentUUID: string) {
  const [podList, setPodList] = useState<POD[]>([])
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)
  const configs = useConfigContext()
  const enableAttachmentsEndpointForPods = configs.enableAttachmentsEndpointForPods.toBoolean()

  const fetchPOD = useCallback(
    async (uuid: string, abortController?: AbortController) => {
      setRequestStatus(RequestStatus.Pending)

      try {
        const result = await getShipmentPODs(uuid, {
          signal: abortController?.signal,
          enableAttachmentsEndpointForPods,
        })
        setPodList(result)
        setRequestStatus(RequestStatus.Done)
      } catch (error) {
        if (!abortController?.signal.aborted) {
          sentry.log(error)
          setRequestStatus(RequestStatus.Error)
        }
      }
    },
    [enableAttachmentsEndpointForPods]
  )

  useEffect(() => {
    const abortController = new AbortController()

    fetchPOD(shipmentUUID, abortController)

    return () => {
      abortController.abort()
    }
  }, [fetchPOD, shipmentUUID])

  return { podList, fetchPOD, requestStatus, podUrl: 'url' }
}
